import { get, isArray, isObject, size } from 'lodash';

export default class Response<T = any> {
  public rawResponse;
  public data: T;
  public error;
  public meta;
  public isSuccess;
  public isFailure;

  constructor(response, meta?) {
    this.rawResponse = response;
    this.data = response;
    this.error = false;
    this.meta = meta;
    this.isSuccess = true;
    this.isFailure = false;
  }

  getData = () => {
    return get(this, 'data');
  };

  getField = (key) => get(this, `data.${key}`);

  getCount = () => {
    if (isArray(this.data) || isArray(get(this.data, 'items'))) {
      return size(get(this.data, 'items', this.data));
    }
    if (isObject(this.data)) {
      return 1;
    }

    return 0;
  };

  getStatus = () => {
    return get(this.rawResponse, 'status', 503);
  };

  getError = (key?): Error => get(this.error, key, this.error);

  getErrorMessage = () => this.error.message;

  throwError = () => {
    throw this.error;
  };

  isNotFound = () => this.getStatus() === 404;
}
